import { createSlice } from '@reduxjs/toolkit'
import newsItem from "./newsItem";

let preparer = (payload, meta) => ({
  payload, meta
});

export const comicNewsSlice = createSlice({
  name: 'comicNews',
  initialState: {
    "hoh": {},
    "aptgg": {},
  },
  reducers: {
    loading: {
      prepare: preparer,
      reducer: (state, action) => {
        state[action.meta.story][action.meta.id] = {
          ...state[action.meta.story][action.meta.id],
          loading: true,
          failed: false,
        };
      }
    },
    error: {
      prepare: preparer,
      reducer: (state, action) => {
        state[action.meta.story][action.meta.id] = {
          ...state[action.meta.story][action.meta.id],
          loading: false,
          failed: true,
        };
      }
    },
    success: {
      prepare: preparer,
      reducer: (state, action) => {
        state[action.meta.story][action.meta.id] = {
          loading: false,
          failed: false,
          ...newsItem(action.payload),
        };
      }
    }
  }
});

export const actions = comicNewsSlice.actions;

export default comicNewsSlice.reducer;